import type { ExcursionComponentProps } from "@op/puck-types";
import { LayerProvider, useExcursionContext } from "@op/utils";
import { useEffect, useState } from "react";
import { Root, Content, Overlay } from "vaul";
import { ExcursionRenderer } from "../../../../../renderer";

const Excursion = ({ slug, data, index }: ExcursionComponentProps) => {
  const [open, setOpen] = useState<boolean>(true);
  const { closeUppermostExcursion } = useExcursionContext();

  useEffect(() => {
    if (open) return;
    setOpen(false);
    setTimeout(() => {
      closeUppermostExcursion();
    }, 100);
  }, [open]);

  return (
    <Root
      shouldScaleBackground
      noBodyStyles
      open={open}
      nested={index > 0}
      handleOnly
      onOpenChange={setOpen}
    >
      <Overlay className="fixed inset-0 z-20 bg-black/40" />
      <Content
        className="bg-neutral-0 flex flex-col rounded-t-[10px] h-full mt-24 max-h-[94%] fixed bottom-0 left-0 right-0 z-30"
        style={{
          maxHeight: `calc(98% - ${index * 2}rem)`,
        }}
        id={slug}
      >
        <LayerProvider type="excursion" slug={slug}>
          <ExcursionRenderer data={data} />
        </LayerProvider>
      </Content>
    </Root>
  );
};

export default Excursion;
